module.exports = __webpack_public_path__ + "static/img/bells.15e856b5.png";